// extracted by mini-css-extract-plugin
export default {"root":"styles_root__ZY+Vl","title":"styles_title__M0TfE","closeButton":"styles_closeButton__zRmfA","actions":"styles_actions__wEWAM"};